import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Layout from '../Layout';

class AvatarView extends Component{

  render(){
    return(
      <Layout {...this.props} type="AvatarView"/>
    )
  }
}

AvatarView.propTypes = {
  childOf:PropTypes.string,
  values:PropTypes.object,
  cell: PropTypes.array,
  layout:PropTypes.func
};
 
export default AvatarView;



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Content/AvatarView.js